import { DateHelper } from "apps/idl/src/helpers/dateHelper";
import { ETimetablePattern } from "apps/idl/src/model/date/ETimetablePattern";
import { Entity } from "apps/idl/src/model/entities/Entity";
import { EAvatarSize } from "apps/idl/src/model/picture/EAvatarSize";
import { EntityBuilder } from "apps/idl/src/services/security";
import { C_PLANNING_DB_ROLE, C_PREFIX_PLANNING_RH } from "../../../app/app.constants";
import { IPlanningRH } from './IPlanningRH';

export class PlanningRHEntityBuilder extends EntityBuilder<IPlanningRH>{
	constructor() {
		super(
			(psModelId: string) => RegExp(C_PREFIX_PLANNING_RH).test(psModelId),
			(poPlanningRH: IPlanningRH) => new Entity(
				poPlanningRH,
				`planning-rh/${DateHelper.transform(poPlanningRH.startDate, ETimetablePattern.isoFormat_hyphen)}`,
				() => `Planning du ${DateHelper.transform(poPlanningRH.startDate, ETimetablePattern.dd_MMMM_yyyy)}`
			),
			(psModelId: string) => "Plannings",
			C_PLANNING_DB_ROLE,
			C_PREFIX_PLANNING_RH,
			() => ({
				size: EAvatarSize.medium,
				icon: "planning-rh"
			})
		);
	}
}